@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/miss-jones-index-card-stack-content/miss-jones-index-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  display: flex;
  font-family: oswald, sans-serif;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  overflow: hidden;
  --badge-grid-min-col: calc(1.25rem * 0.83);
}
:host .header {
  color: white;
  display: flex;
  padding: 0.75rem 0;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  font-size: calc(1.25rem * 0.83);
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: 0.15rem;
  text-transform: uppercase;
}
:host .main-content {
  flex: 1;
  padding: calc(1rem * 0.83) calc(1.5rem * 0.83);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: calc(1.5rem * 0.83);
}
:host .main-content .top-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
:host .main-content .top-content .miss-jones-brand {
  font-family: futura-pt, sans-serif;
  font-size: calc(0.75rem * 0.83);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
:host .main-content .top-content .miss-jones-logo {
  width: calc(1.5rem * 0.83);
}
:host .main-content .craft-badge-container {
  height: calc(2.5rem * 0.83);
}
:host .main-content .craft-badge-container .craft-badge {
  width: calc(2.5rem * 0.83);
  height: calc(2.5rem * 0.83);
}
:host .main-content .center-content {
  height: calc(10.375rem * 0.83);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
}
:host .main-content .center-content.no-craft-badge {
  height: calc(14.375rem * 0.83);
}
:host .main-content .center-content .product-name {
  font-family: rama-gothic-m, sans-serif;
  font-size: calc(3.5rem * 0.83);
  font-style: normal;
  font-weight: 600;
  line-height: 90%;
  letter-spacing: 0.03rem;
  text-transform: uppercase;
  padding-bottom: 0.25rem;
}
:host .main-content .center-content .strain-label-badge-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: calc(0.5rem * 0.83);
  row-gap: calc(0.5rem * 0.83);
  overflow-x: clip;
  height: calc(1.25rem * 0.83);
}
:host .main-content .center-content .strain-label-badge-container .strain-type {
  color: #222222;
  font-size: calc(1.25rem * 0.83);
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: 0.15rem;
  text-transform: uppercase;
}
:host .main-content .center-content .strain-label-badge-container .badge-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: calc(0.5rem * 0.83);
  justify-content: center;
  align-items: center;
}
:host .main-content .center-content .strain-label-badge-container .badge-container .badge {
  height: calc(1.25rem * 0.83);
}
:host .main-content .center-content .label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
:host .main-content .center-content .label ::ng-deep .product-label {
  font-family: oswald, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: calc(0.75rem * 0.83);
  line-height: normal;
  border-radius: calc(0.125rem * 0.83);
  margin: 0;
  width: fit-content;
  padding: 0 calc(0.3125rem * 0.83) calc(0.125rem * 0.83) calc(0.3125rem * 0.83);
}
:host .main-content .center-content ::ng-deep .description-container {
  height: calc(6rem * 0.83);
}
:host .main-content .center-content ::ng-deep .description-container .description {
  font-family: futura-pt, sans-serif;
  font-size: calc(0.9375rem * 0.83);
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  padding-top: 1rem;
}
:host .main-content .center-content ::ng-deep .description-container .plain-text {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
:host .main-content .center-content ::ng-deep .description-container .rich-text {
  max-height: calc(5rem * 0.83);
  overflow-y: hidden;
}
:host .main-content .bottom-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 0 0;
  gap: calc(1rem * 0.83);
}
:host .main-content .bottom-content .properties-and-price {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
}
:host .main-content .bottom-content .properties {
  width: 51%;
}
:host .main-content .bottom-content .properties .property-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: calc(0.375rem * 0.83);
  box-sizing: border-box;
}
:host .main-content .bottom-content .properties .property-container .title {
  font-size: calc(1rem * 0.83);
  font-weight: 400;
  line-height: 120%;
}
:host .main-content .bottom-content .properties .property-container .value {
  font-size: calc(1rem * 0.83);
  font-weight: 300;
  line-height: 120%;
}
:host .main-content .bottom-content .product-card-price ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: calc(2.5rem * 0.83);
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  overflow: visible;
}
:host .main-content .bottom-content .product-card-price ::ng-deep .product-variant-price .product-variant-previous-price {
  opacity: 0.5;
  font-size: calc(1.75rem * 0.83);
}
:host .main-content .bottom-content .product-notes-and-sizing {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  padding-bottom: calc(2.625rem * 0.83);
}
:host .main-content .bottom-content .product-notes-and-sizing .notes-container {
  display: flex;
  flex-direction: column;
  gap: calc(0.75rem * 0.83);
}
:host .main-content .bottom-content .product-notes-and-sizing .notes-container .notes .title {
  font-family: futura-pt, sans-serif;
  font-size: calc(0.75rem * 0.83);
  font-style: normal;
  font-weight: 600;
}
:host .main-content .bottom-content .product-notes-and-sizing .notes-container .notes .info {
  font-family: futura-pt, sans-serif;
  font-size: calc(0.75rem * 0.83);
  font-style: normal;
  font-weight: 400;
}
:host .main-content .bottom-content .product-notes-and-sizing .sizing {
  font-family: futura-pt, sans-serif;
  font-size: calc(1rem * 0.83);
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  min-width: fit-content;
}
/*# sourceMappingURL=miss-jones-index-card-stack-content.component.css.map */
